module.exports = __webpack_public_path__ + "images/halloween_lp/sec01_step2_68a56e96ba9176e2891cb92e43fe1cce.png";